import { SxProps } from '@mui/material/styles';

import { AttachmentSearchQuerySerialized } from '@playq/services-beetle';

export enum BeetleBreadcrumbComponent {
  ISSUES_TABLE = 'IssuesTable',
  SUPPORT_REQUESTS_TABLE = 'SupportRequestsTable',
  ISSUE = 'Issue',
  SUPPORT_REQUEST = 'SupportRequest',
}
export enum SupportBreadcrumbsRoute {
  Lookup = 'BeetleLookup',
  Clusterization = 'Clusterization',
  Leaderboards = 'Leaderboards',
  TeamLookup = 'TeamsLookup',
}
interface RouteConfig {
  path: string;
  breadcrumb?: string;
}
export interface IBeetleBreadcrumbsProps {
  homeRoute?: boolean;
  routes: RouteConfig[];
  title?: string | undefined;
  attachmentsQuery?: Partial<AttachmentSearchQuerySerialized>;
  mobile?: boolean;
  sx?: SxProps;
}
export interface RouteParams {
  appName: string;
  type: string;
  env: string;
}
export type ITeamTitleParams = Partial<{ name: string; templateName: string }>;
export interface IRouteTeam extends RouteParams {
  templateId: string;
  teamName?: string;
  teamId: string;
}
export interface IRouteBeetle extends RouteParams {
  app: string;
  id: string;
}
export interface IRouteCluster extends RouteParams {
  titleTask: string;
  runId: string;
  tab: string;
  id: string;
}

export interface IRouteLeaderboard extends RouteParams {
  id: string;
}

export type RouteParamsMap = {
  [SupportBreadcrumbsRoute.Lookup]: IRouteBeetle;
  [SupportBreadcrumbsRoute.Clusterization]: IRouteCluster;
  [SupportBreadcrumbsRoute.Leaderboards]: IRouteLeaderboard;
  [SupportBreadcrumbsRoute.TeamLookup]: IRouteTeam;
};

export type RouteTitleMap = {
  [SupportBreadcrumbsRoute.Lookup]: string | undefined;
  [SupportBreadcrumbsRoute.Clusterization]: string | undefined;
  [SupportBreadcrumbsRoute.Leaderboards]: string | undefined;
  [SupportBreadcrumbsRoute.TeamLookup]: ITeamTitleParams | undefined;
};
export type RouteGeneratorMap = {
  [K in SupportBreadcrumbsRoute]: (params: RouteParamsMap[K], title?: RouteTitleMap[K]) => RouteConfig[];
};
